export function formatPrice(price) {
    if (isNaN(price)) {
        return price;
    }
    price = price.toFixed(2);
    return `${price} €`;
}